var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292944 6.66008C-0.0975799 7.0506 -0.09758 7.68377 0.292944 8.07429L6.6569 14.4383C7.04743 14.8288 7.68059 14.8288 8.07112 14.4383C8.46164 14.0477 8.46164 13.4146 8.07112 13.024L2.41426 7.36719L8.07112 1.71033C8.46164 1.31981 8.46164 0.686643 8.07112 0.296118C7.6806 -0.0944063 7.04743 -0.0944064 6.65691 0.296118L0.292944 6.66008ZM17.2177 7.36719L17.2177 6.36719L1.00005 6.36718L1.00005 7.36718L1.00005 8.36718L17.2177 8.36719L17.2177 7.36719Z",
    fill: "#F3F0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/ArrowBlack.3d48dac2e82f39abbf01de522185de65.svg";
export { ForwardRef as ReactComponent };